<script setup lang="ts">
    import { computed } from 'vue';
    import { formatChangeValue, truncate } from '@/formatters';
    import { ChangeAttributeValue } from '@/shared/helpers/api/types/entities.ts';

    type Props = {
        text?: ChangeAttributeValue;
        length?: number;
    };

    const props = withDefaults(defineProps<Props>(), {
        text: '',
        length: 40
    });

    const displayText = computed(() => {
        const value = formatChangeValue(props.text);
        if (typeof value === 'string') {
            return truncate(value, props.length);
        }
        return value;
    });
    const titleText = computed(() => String(props.text ?? ''));
</script>

<template>
    <span
        class="keep-spaces"
        :title="titleText"
        v-text="displayText" />
</template>

<style scoped>
    .keep-spaces {
        white-space: pre-wrap;
    }
</style>
